import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { DynamicIcon } from "@/lib/icons";

export function ServicesSection({ services = [], columns = 3 }) {
  return (
    <div
      data-testid="services-section"
      className={`grid gap-4 sm:grid-cols-2 ${columns === 3 ? "lg:grid-cols-3" : "lg:grid-cols-2"}`}
    >
      {services.map((service, i) => (
        <div
          key={service.id || service.title}
          data-testid={`service-card-${i}`}
          style={{ animationDelay: `${i * 50}ms` }}
          className="group animate-fade-up rounded-2xl border border-line bg-white p-6 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(0,0,0,0.08)]"
        >
          <div className="flex items-start justify-between">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-light text-brand transition-transform duration-300 group-hover:scale-110">
              <DynamicIcon name={service.icon} className="h-[22px] w-[22px]" />
            </span>
            <ArrowUpRight className="h-4 w-4 text-slate-300 transition-colors duration-200 group-hover:text-brand" />
          </div>
          <h3 className="mt-5 font-display text-[17px] font-bold text-ink">{service.title}</h3>
          <p className="mt-2 text-sm leading-relaxed text-slate-500">{service.description}</p>
        </div>
      ))}
      <Link
        to="/support#ticket"
        data-testid="services-contact-card"
        className="flex flex-col justify-between rounded-2xl bg-ink p-6 text-white transition-colors duration-300 hover:bg-brand"
      >
        <span>
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-white/60">Besoin d'un devis ?</span>
          <span className="mt-3 block font-display text-xl font-bold">Parlez à un technicien</span>
          <span className="mt-2 block text-sm text-white/70">
            Décrivez votre besoin, nous répondons sous 2 heures ouvrées.
          </span>
        </span>
        <span className="mt-6 inline-flex items-center gap-2 text-sm font-bold">
          Contacter le support <ArrowUpRight className="h-4 w-4" />
        </span>
      </Link>
    </div>
  );
}

export default ServicesSection;
